import React, {useEffect} from "react";
import {connect, useSelector} from "react-redux";
import {Card, CardBody, CardTitle} from "reactstrap";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";



// components
import PromotionActivityForm from "./_form";
import PromotionActivityFilters from "./_filters";
import {ConfirmDelete} from "../../../components/confirmAlert/ConfirmDelete";
import {ModalFormContainer} from "../../../components/confirmAlert/ModalFormContainer";
import {ActiveFormatter} from "../../../components/tables/activeFormater";
import {GenericButton} from "../../../components/buttons/customButtons";

// labels
import {TT_DELETE, TT_EDIT} from "../../../components/i18n/toolTips";
import {LB_ACTIONS, LB_UDN, NO_DATA_FOUND} from "../../../components/i18n/i18n";

// actions
import { setFilter, setTableParams, setForm, setItem } from "../../../redux/actions/generics/IndexedActions";
import {genericIndexedActions} from "../../../redux/actions/generics/GenericIndexedActions";

// services
import {promotionActivityService} from "../../../jwt/_services/promotions/promotionActivityService";

// utils
import {getStateByPath} from "../../../redux/selectors";
import ConfirmationSendingNotification from "./_confirmationSendingNotification";




const PromotionActivityList = (props) => {
    const {path} = props
    const componentState = useSelector(state => getStateByPath(state, path));
    const {app, pageSize, pageIndex, totalSize, listDomainObjects, filter} = componentState?.data || {};

    const {fbDataBase} = app

    useEffect(() => {
        if (filter || !app?.id)
            return

        props.setFilter(path, {
            fbDataBase,
            item: {code: null}
        })
    }, [app]);


    useEffect(() => {
        if (!filter)
            return

        genericIndexedActions.search(path, promotionActivityService, pageIndex, pageSize, filter)
    }, [pageIndex, pageSize, filter]);


    const editItem = data => {
        props.setItem(path, data);
        props.setForm(path, true, false, false);

        ModalFormContainer(PromotionActivityForm, {path, data})
    }

    const createItem = () => {
        props.setItem(path, null);
        props.setForm(path)

        ModalFormContainer(PromotionActivityForm, {path})
    }


    const confirmDelete = data => ConfirmDelete({
        path,
        data,
        fbDataBaseId: fbDataBase?.id,
        service: promotionActivityService,
        remove: genericIndexedActions.delete,
    });


    const confirmNotification = promotionActivity => ModalFormContainer(ConfirmationSendingNotification,{promotionActivity})



    const handleTableChange = (type, {page, sizePerPage}) => {
        let currentIndex = (page - 1) * sizePerPage
        props.setTableParams(path, sizePerPage, currentIndex, totalSize, currentIndex)
    };


    const columns = [
        {
            dataField: 'id',
            text: 'ID',
            hidden: true
        }, {
            dataField: 'udn',
            text: `${LB_UDN}`,
            headerStyle: {width: '150px'},
            formatter: (cell, row) => <>{row?.udn?.title}</>,
        }, {
            dataField: 'activity',
            text: `Actividad`,
            formatter: (cell, row) => <>{row?.activity?.name}</>,
        }, {
            dataField: 'porcentaje',
            text: `Porcentaje de Descuento`,
            headerStyle: {width: '190px'},
            headerAlign: 'center',
            align: 'center',
            formatter: (cell, row) => <>{row?.porcentaje}%</>,
        }, {
            dataField: 'monto',
            text: `Monto de descuento`,
            headerStyle: {width: '150px'},
            headerAlign: 'center',
            align: 'center',
            formatter: (cell, row) => <>${row?.monto}</>,
        }, {
            dataField: 'active',
            text: "Activo",
            headerStyle: {width: '30px'},
            headerAlign: 'center',
            align: 'center',
            formatter: (cell) => <ActiveFormatter active={cell}/>
        }, {
            dataField: 'actions',
            isDummyField: true,
            text: `${LB_ACTIONS}`,
            headerAlign: 'center',
            align: 'center',
            headerStyle: {width: '195px'},
            formatter: (cell, row) => buttons(row)
        }];

    const buttons = row => <>
        <GenericButton
            style={'table'}
            toolTip={TT_EDIT}
            icon={'fa fa-pen'}
            permission={'edit'}
            onClick={() => editItem(row)}
        />
        {
            row?.wasNotified === true
                ? <GenericButton
                    style={'table'}
                    toolTip={'Notificar'}
                    icon={'fa fa-paper-plane-o'}
                    permission={'edit'}
                    onClick={() => confirmNotification(row)}
                /> : <GenericButton
                    style={'table'}
                    toolTip={'Esta promoción no ha sido notificada'}
                    icon={'fa fa-paper-plane-o'}
                    stackedIcon={'fa fa-exclamation-circle text-danger'}
                    permission={'add'}
                    onClick={() => confirmNotification(row)}
                />
        }

        <GenericButton
            style={'table'}
            toolTip={TT_DELETE}
            icon={'fa-trash'}
            permission={'delete'}
            onClick={() => confirmDelete(row)}
        />
    </>

    return <Card>
        <CardTitle className="bg-light border-bottom p-3 mb-0">
            <i className="far fa-list-alt mr-2"/>{`Lista de Promociones Existentes`}
            <div className="float-right">
                <GenericButton
                    style={'table'}
                    label={'Agregar'}
                    toolTip={'Agregar'}
                    icon={'fa-plus'}
                    permission={'add'}
                    onClick={createItem}
                />
            </div>
        </CardTitle>

        <PromotionActivityFilters path={path}/>

        <CardBody>
            <BootstrapTable
                striped hover
                tableHeaderClass='mb-0'
                remote
                keyField="id"
                data={listDomainObjects || []}
                columns={columns}
                noDataIndication={NO_DATA_FOUND}
                pagination={paginationFactory({pageIndex, pageSize, totalSize})}
                onTableChange={handleTableChange}
            />
        </CardBody>
    </Card>
}

const mapStateToProps = state => ({})
const mapActionsToProps = ({
    setFilter,
    setTableParams,
    setForm,
    setItem,
})

export default connect(mapStateToProps, mapActionsToProps)(PromotionActivityList);